import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import "./AnnouncementPage.css";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

export default function AnnouncementPage() {
  const navigate = useNavigate();

  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [senderName, setSenderName] = useState("");
  const [senderRole, setSenderRole] = useState("");
  const [loading, setLoading] = useState(false);

  // Load current user from localStorage
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setSenderName(user.fullname);
      setSenderRole(user.systemRole);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!subject || !message) {
      alert("Please fill in both Subject and Message.");
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${API_BASE_URL}/alumni/announcement`, {
        subject,
        message,
        senderName,
        senderRole,
      });

      alert("Announcement sent successfully!");
      navigate(-1); // Go back
    } catch (err) {
      console.error("Failed to send announcement:", err);
      alert("Failed to send announcement. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="announcement-page">
      {/* Go Back Button */}
      <button className="btn-back" onClick={() => navigate(-1)}>
        <ArrowLeft size={16} /> Go Back
      </button>

      <div className="announcement-card">
        <h1>Send Announcement</h1>

        <form onSubmit={handleSubmit}>
          {/* Sender Name */}
          <div className="form-group">
            <label htmlFor="senderName">Sender Name</label>
            <input
              type="text"
              id="senderName"
              value={senderName}
              disabled
            />
          </div>

          {/* Sender Role */}
          <div className="form-group">
            <label htmlFor="senderRole">Role</label>
            <input
              type="text"
              id="senderRole"
              value={senderRole}
              disabled
            />
          </div>

          {/* Subject */}
          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <input
              type="text"
              id="subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Enter announcement subject"
              required
            />
          </div>

          {/* Message */}
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Type your announcement here..."
              rows={6}
              required
            ></textarea>
          </div>

          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? "Sending..." : "Send Announcement"}
          </button>
        </form>
      </div>
    </div>
  );
}